// The onSubmit handler can return either void or Promise<void | T>, which triggers
// the no-misused-promises rule when passed to form.handleSubmit. This is a false positive
// since react-hook-form properly handles both synchronous and asynchronous submit handlers.
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormProvider } from 'react-hook-form';
import { FormProps } from '../../../types/fileExplorerTypes';
import { FolderSchema } from './schemas';
import { CheckboxField, InputField } from '../../Forms/Fields';
import { FolderOptions } from './constants';

export function FolderForm({
  form, onSubmit, children, ...rest
}: FormProps<FolderSchema>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="modal-form" {...rest}>
        <InputField<FolderSchema>
          id="name"
          path="name"
          label="Nombre"
          placeholder="Nombre de la carpeta"
          required
        />
        <InputField<FolderSchema>
          id="description"
          path="description"
          label="Descripción"
          placeholder="Descripción de la carpeta"
        />
        <CheckboxField<FolderSchema>
          options={FolderOptions.asCheckboxOptions()}
          label="Remover prefijo de archivos directos de esta carpeta"
          orientation="horizontal"
          pathsMap={{
            remove_file_prefix: 'remove_file_prefix',
          }}
        />
        {children}
      </form>
    </FormProvider>
  );
}
